var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_vm._v("\n  컴포넌트 팝업 입니다.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }